import scrollTo from './helpers/scrollTo';

const SELECTORS = {
    container: '.js-to-top',
    button: '.js-to-top-button',
};
const MODIFIER = 'visible';
const MIN_SCROLL_DISTANCE = 100;

function initToTop() {
    const TO_TOP_NODES = [...document.querySelectorAll(SELECTORS.container)];
    const TO_TOP_BUTTON_NODES = [...document.querySelectorAll(SELECTORS.button)];

    if (TO_TOP_NODES) {
        document.addEventListener('scroll', scrollHandler, { capture: false, passive: true });
    }

    if (TO_TOP_BUTTON_NODES) {
        TO_TOP_BUTTON_NODES.forEach((button) => {
            button.addEventListener('click', clickHandler);
        });
    }

    function scrollHandler() {
        if (window.scrollY >= MIN_SCROLL_DISTANCE) {
            TO_TOP_NODES.forEach((toTopNode) => {
                toTopNode.classList.add(MODIFIER);
            });
        } else {
            TO_TOP_NODES.forEach((toTopNode) => {
                toTopNode.classList.remove(MODIFIER);
            });
        }
    }

    function clickHandler() {
        scrollTo({ target: 0 });
    }
}

export { initToTop };
